import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useCallback } from 'react';

import {
  Box,
  Paper,
  Typography,
  Grid,
  Switch,
  FormControlLabel,
  Container,
  TextField,
  Button,
  Card, MenuItem,
  CardMedia
} from '@mui/material';
import AdminLayout from './Admin_Layout/AdminLayout';
import JoditEditor from 'jodit-react';
import { useNavigate, useLocation } from 'react-router-dom';

const AddEvents = (props) => {
  const [events, setEvents] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { data = {} } = location.state || {}; // Retrieve state or use defaults
  const eventTypes = ["SSW", "CSG", "SSL", "NCOJ", "CSAW"];
  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setActiveEvent({
        _id: data._id || '',
        heading: data.heading || '',
        description: data.description || '',
        longdescription: data.longdescription || '',
        type: data.type || '',
       archieved: typeof data.archieved === 'boolean' ? data.archieved : false,
        venue: data.venue || '',
        details: data.details || '',
        organizer: data.organizer || '',
        joinLink: data.joinLink || '',
        youtubeLink: data.youtubeLink || '',
        date: data.date || '',
        time: data.time || '',
        register: data.register || '',
        imageURL: data.imageURL || '',
      });
    }
  }, [data]);


  const [activeEvent, setActiveEvent] = useState(
    { _id: '', heading: '', description: '', longdescription: '', type: '', archieved: false, venue: '', details: '', organizer: '', joinLink: '', youtubeLink: '', date: '', time: '', register: '', ...data }


  ); // State for the active event
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  //const editor = useRef(null); // Ref for Jodit Editor
  const shortEditor = useRef(null);
  const longEditor = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setActiveEvent((prev) => ({ ...prev, [name]: value }));
  };

  const handleShortDescriptionChange = useCallback((newContent) => {
    setActiveEvent((prev) => ({ ...prev, description: newContent }));
  }, []);

  const handleLongDescriptionChange = useCallback((newContent) => {
    setActiveEvent((prev) => ({ ...prev, longdescription: newContent }));
  }, []);


  const editorConfig = useMemo(() => ({
    readonly: false,
    height: 300,
    placeholder: "Start typing...",
  }), []);


  const handleSave = async () => {
    try {
      const formData = new FormData();

      // Append description and image (if selected) to the FormData
      formData.append("description", activeEvent.description);
      formData.append("longdescription", activeEvent.longdescription);
      formData.append("heading", activeEvent.heading);
      formData.append("type", activeEvent.type);
      formData.append("archieved", activeEvent.archieved);
      formData.append("venue", activeEvent.venue);
      formData.append("details", activeEvent.details);
      formData.append("organizer", activeEvent.organizer);
      formData.append("joinLink", activeEvent.joinLink);
      formData.append("youtubeLink", activeEvent.youtubeLink);
      formData.append("date", activeEvent.date);
      formData.append("time", activeEvent.time);
      formData.append("register", activeEvent.register);

      if (activeEvent.imageFile) {
        formData.append("image", activeEvent.imageFile);
      }

      const isUpdate = activeEvent._id !== "";

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/events${isUpdate ? `/${activeEvent._id}` : ''}`,
        {
          method: isUpdate ? "PUT" : "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Failed to save/update event.");

      const updatedEvent = await response.json();
      alert(isUpdate ? "Event updated!" : "Event added!");
      navigate("/admin-dashboard/update-events");
    } catch (error) {
      console.error("Error saving event:", error.message);
      alert("Failed to save event.");
    }
  };


  {/* async function updateEvent(){
    const formData = new FormData();
  
        // Append description and image (if selected) to the FormData
        formData.append("description", activeEvent.description);
        formData.append("longdescription", activeEvent.longdescription);
        formData.append("heading", activeEvent.heading);
        formData.append("type", activeEvent.type);
        formData.append("archieved", activeEvent.archieved);
        formData.append("venue", activeEvent.venue);
        formData.append("details", activeEvent.details);
        formData.append("organizer", activeEvent.organizer);
        formData.append("joinLink", activeEvent.joinLink);
        formData.append("youtubeLink", activeEvent.youtubeLink);
        formData.append("date", activeEvent.date);
        formData.append("time", activeEvent.time);
        formData.append("register", activeEvent.register);

        if (activeEvent.imageFile) {
          // console.log('image foundnddd')
          formData.append("image", activeEvent.imageFile); // Key name must match your backend's `req.file` handler
        }
  
        // Send the data to the backend using fetch
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/events/${activeEvent._id}`,
          {
            method: "PUT",
            body: formData,
          }
        );
  
        if (!response.ok) {
          throw new Error("Failed to update event.");
        }
  
       const updatedEvent = await response.json();
         setActiveEvent(updatedEvent)
        navigate('/admin-dashboard/update-events')
  }
*/}
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file); // Create a temporary URL for preview

      setActiveEvent((prev) => ({
        ...prev,
        imageFile: file,
        imageURL: imageUrl, // Set preview URL
      }));
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        Loading...
      </Box>
    );
  }

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography color="error">{error}</Typography>
      </Container>
    );
  }

  return (
    <AdminLayout>
      <Box sx={{ p: { xs: 2, sm: 3 }, pt: { xs: 8, sm: 9 } }}>
        <Container maxWidth="lg">
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: "background.paper",
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography variant="h4" gutterBottom>
              {Object.keys(data).length !== 0 ? 'Update Event' : 'Add Event'}
            </Typography>

            {activeEvent && (
              <Box component="form" sx={{ mt: 3 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Event Heading"
                      name="heading"
                      value={activeEvent.heading || ""}
                      onChange={handleInputChange}
                      placeholder="Enter Event Heading"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Event Venue"
                      name="venue"
                      value={activeEvent.venue || ""}
                      onChange={handleInputChange}
                      placeholder="Enter Event Venue"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Event Date"
                      name="date"
                      value={activeEvent.date || ""}
                      onChange={handleInputChange}
                      placeholder="Enter Event Date"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Event time"
                      name="time"
                      value={activeEvent.time || ""}
                      onChange={handleInputChange}
                      placeholder="Enter Event time"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="Event Type"
                      name="type"
                      value={activeEvent.type || ""}
                      onChange={handleInputChange}
                      placeholder="Select Event Type"
                      required
                    >
                      {eventTypes.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>



                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={Boolean(activeEvent.archieved)}
                          onChange={(e) =>
                            setActiveEvent((prev) => ({ ...prev, archieved: e.target.checked }))
                          }
                          name="archieved"
                          color="primary"
                        />
                      }
                      label="Archived"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Event Organizer"
                      name="organizer"
                      value={activeEvent.organizer || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Event Register Link"
                      name="register"
                      value={activeEvent.register || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Description
                    </Typography>

                    <JoditEditor
                      ref={shortEditor}
                      value={activeEvent.description}
                      config={editorConfig}
                      onChange={handleShortDescriptionChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      LongDescription
                    </Typography>
                    <JoditEditor
                      ref={longEditor}
                      value={activeEvent.longdescription}
                      config={editorConfig}
                      onChange={(newContent) => {
                        console.log("Jodit long description change:", newContent);
                        setActiveEvent((prev) => ({ ...prev, longdescription: newContent }));
                      }}
                    />


                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Join Link"
                      name="joinLink"
                      value={activeEvent.joinLink || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Youtube Link"
                      name="youtubeLink"
                      value={activeEvent.youtubeLink || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                      id="imageUploadNew"
                    />
                    <label htmlFor="imageUploadNew">
                      <Button variant="contained" color="primary" component="span">
                        {Object.keys(data).length !== 0 ? 'Change Image' : 'Add Image'}
                      </Button>
                    </label>
                  </Grid>

                  {activeEvent.imageURL && (
                    <Grid item xs={12}>
                      <Card sx={{ maxWidth: 200, mt: 2 }}>
                        <CardMedia
                          component="img"
                          image={activeEvent.imageURL}
                          alt="Uploaded Image"
                        />
                      </Card>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Button
                      type="button"
                      variant="contained"
                      size="large"
                      onClick={handleSave}

                    >
                      {Object.keys(data).length !== 0 ? 'Update Event' : 'Add Event'}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Paper>
        </Container>
      </Box>
    </AdminLayout>
  );
};

export default AddEvents;
